import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const galleryImages = [
  { url: "/images/store-front.jpeg", alt: "Al-Kasbah Store" },
  { url: "/images/images (28).jpeg", alt: "Al-Kasbah Store" },
  { url: "/images/images (2).jpeg", alt: "Al-Kasbah Store" },
    { url: "/images/images (3).jpeg", alt: "Al-Kasbah Store" },
      { url: "/images/images (14).jpeg", alt: "Al-Kasbah Store" },
      { url: "/images/images (17).jpeg", alt: "Al-Kasbah Store" },
      { url: "/images/images (10).jpeg", alt: "Al-Kasbah Store" },
        { url: "/images/meat.png", alt: "Al-Kasbah Store" },
        { url: "/images/fridge.jpeg", alt: "Al-Kasbah Store" },
        { url: "/images/images (29).jpeg", alt: "Al-Kasbah Store" },
        //11
        { url: "/images/images (27).jpeg", alt: "Al-Kasbah Store" },
          { url: "/images/images (16).jpeg", alt: "Al-Kasbah Store" },
         
  { url: "/images/spices.jpeg", alt: "Al-Kasbah Store" },
  
  
  
  

  
  { url: "/images/images (5).jpeg", alt: "Al-Kasbah Store" },
  
  
  { url: "/images/images (7).jpeg", alt: "Al-Kasbah Store" },
 
  { url: "/images/images (9).jpeg", alt: "Al-Kasbah Store" },
  
 
 
  
  


  
 
  { url: "/images/images (21).jpeg", alt: "Al-Kasbah Store" },
 
  { url: "/images/images (23).jpeg", alt: "Al-Kasbah Store" },
];

const PREVIEW_COUNT = 4;

export default function Gallery() {
  const { t } = useLanguage();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const previewImages = galleryImages.slice(0, PREVIEW_COUNT);
  const remaining = galleryImages.length - PREVIEW_COUNT;

  const goNext = () => {
    setSelectedIndex((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  };

  const goPrev = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  };

  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 lg:py-28 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <h2
            data-testid="gallery-title"
            className="font-heading text-3xl lg:text-4xl font-semibold tracking-tight mb-4"
            style={{ color: "#0A0A0A" }}
          >
            {t("gallery.title")}
          </h2>
          <div className="w-16 h-0.5 mx-auto mb-4" style={{ backgroundColor: "#D4AF37" }} />
          <p className="text-base text-neutral-500">{t("gallery.subtitle")}</p>
        </div>

        {/* Preview Grid - 5 tiles: 4 photos + 1 "more" tile */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 auto-rows-[220px]">

          {previewImages.map((img, index) => (
            <button
              key={index}
              onClick={() => setSelectedIndex(index)}
              className="overflow-hidden rounded-sm group cursor-pointer"
            >
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                loading="lazy"
              />
            </button>
          ))}

          {/* +22 tile */}
          <button
            onClick={() => {
              setShowAll(true);
              setSelectedIndex(PREVIEW_COUNT);
            }}
            className="overflow-hidden rounded-sm cursor-pointer relative flex items-center justify-center"
            style={{ backgroundColor: "#0A0A0A" }}
          >
            <img
              src={galleryImages[PREVIEW_COUNT].url}
              alt="More photos"
              className="w-full h-full object-cover opacity-30"
            />
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <span
                className="font-heading text-4xl font-bold text-white"
              >
                +{remaining}
              </span>
              <span className="text-xs text-white/70 uppercase tracking-widest mt-1">
                {t("gallery.viewAll")}
              </span>
            </div>
          </button>

        </div>
      </div>

      {/* Lightbox Dialog */}
      {selectedIndex !== null && (
        <Dialog open={true} onOpenChange={() => setSelectedIndex(null)}>
          <DialogContent className="max-w-4xl p-0 bg-black border-0">
            <DialogTitle className="sr-only">Gallery</DialogTitle>

            {/* Close button */}
            <button
              onClick={() => setSelectedIndex(null)}
              className="absolute top-3 right-3 z-50 text-white bg-black/50 rounded-full p-1 hover:bg-black/80 transition-colors"
            >
              <X className="h-5 w-5" />
            </button>

            {/* Prev button */}
            <button
              onClick={goPrev}
              className="absolute left-3 top-1/2 -translate-y-1/2 z-50 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition-colors"
            >
              <ChevronLeft className="h-6 w-6" />
            </button>

            {/* Next button */}
            <button
              onClick={goNext}
              className="absolute right-3 top-1/2 -translate-y-1/2 z-50 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition-colors"
            >
              <ChevronRight className="h-6 w-6" />
            </button>

            {/* Image */}
            <img
              src={galleryImages[selectedIndex].url}
              alt={galleryImages[selectedIndex].alt}
              className="w-full max-h-[85vh] object-contain"
            />

            {/* Counter */}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 text-white/60 text-xs">
              {selectedIndex + 1} / {galleryImages.length}
            </div>

          </DialogContent>
        </Dialog>
      )}
    </section>
  );
}